// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dashboard__calendar-wrapper .fc-timeGridDay-view .fc-time-grid .fc-slats td {\n  height: 1.3em;\n}\n@media (max-width: 1069px) and (min-width: 768px) {\n.bView .dashboard__section .assignment__link:nth-child(6) ~ .assignment__link {\n    display: none;\n}\n}\n@media (max-width: 767px) {\n.bView .dashboard__section .assignment__link:nth-child(5) ~ .assignment__link {\n    display: none;\n}\n}\n", ""]);
// Exports
module.exports = exports;
